var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 680.764,
    height: 528.354,
    viewBox: "0 0 180.119 139.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.59 -66.639)",
    paintOrder: "fill markers stroke"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M13.591 66.639H193.71v139.794H13.591z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.507 133.514-34.249 34.249-15.968-15.968-41.938 41.937H178.726z",
    opacity: 0.675,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.217,
    cy: 108.555,
    r: 11.773,
    opacity: 0.675,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.111 77.634h152.614v116.099H26.111z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.ef65149d0731443b8253460c311db11a.svg";
export { ForwardRef as ReactComponent };